import { noop } from '@cian/newbuilding-utils';
import { useEffect, useState } from 'react';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { IBannerEnrichments } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/BannerEnrichments';

import { fetchGetBannerEnrichmentsService } from '../services/fetchGetBannerEnrichmentsService';

const infoForTgbMap = new Map<number, IBannerEnrichments>();

type BannerEnrichmentsParams = {
  dealType?: 'sale' | 'rent';
  objectType?: string;
  objectId?: string;
  useServerEnrichment?: '1';
};

export function useBannerEnrichments({
  objectId,
  objectType,
  dealType,
  useServerEnrichment,
}: BannerEnrichmentsParams): null | IBannerEnrichments {
  const context = useApplicationContext();
  /**
   * @description Только для значений useServerEnrichment === '1' делаем запрос на бекенд для обогащения данных
   */
  const isEnrichmentFromBackendEnabled = useServerEnrichment === '1';

  const objectIdInt = objectId ? parseInt(objectId, 10) : null;

  const [bannerEnrichments, setBannerEnrichments] = useState<null | IBannerEnrichments>(() => {
    /**
     * @description если уже много данных в кеше, то чистим его, по времени нет особого смыла как то кешировать,
     * так же как и какие данные оставлять в кеше
     */
    if (infoForTgbMap.size > 100) {
      infoForTgbMap.clear();

      return null;
    }

    let result: null | IBannerEnrichments = null;

    if (objectIdInt && isEnrichmentFromBackendEnabled) {
      result = infoForTgbMap.get(objectIdInt) ?? null;
    }

    return result;
  });

  useEffect(() => {
    if (isEnrichmentFromBackendEnabled && objectIdInt && !bannerEnrichments) {
      fetchGetBannerEnrichmentsService(context, {
        objectId: objectIdInt,
        dealType,
        objectType,
      }).then(data => {
        if (!data.enrichments) {
          return;
        }

        infoForTgbMap.set(objectIdInt, data.enrichments);

        setBannerEnrichments(data.enrichments);
      }, noop);
    }
    /**
     * @description изменение данных не должно триггерить запрос
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return bannerEnrichments;
}
